import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import {
    differenceInMinutes,
    getDateString,
    getTimestamp,
    OwaDate,
    userDate,
    addHours,
} from 'owa-datetime';

/**
 * Interface for GridLabel
 */
interface GridLabel {
    labelText: string;
    top: number;
}

/**
 * Function to return grid labels
 * @param gridStartTime Start time of grid
 * @param gridEndTime End time of grid
 * @param labels Labels if any passed
 * @param formatTime Formatter to be used
 */
export default function convertTimeLabelsToGridLabels(
    gridStartTime: OwaDate,
    gridEndTime: OwaDate,
    labels?: { [key: number]: string },
    formatTime: (DATE: OwaDate) => string = getDateString
): GridLabel[] {
    if (labels) {
        return Object.keys(labels).map(function (key: string) {
            return {
                labelText: labels[key],
                top: differenceInMinutes(userDate(parseInt(key)), gridStartTime), // TODO: Datetime - parseInt key?
            };
        });
    } else {
        // Generate hourly grid labels by default if no labels provided

        const gridLabels = [];

        // No labels provided so need to generate default labels for hours from start time to end time
        let currentLabelTime = getTimestamp(gridStartTime);
        const endLabelTime = getTimestamp(gridEndTime);

        // First push the top end time label
        gridLabels.push({
            labelText: formatTime(userDate(currentLabelTime)),
            top: differenceInMinutes(userDate(currentLabelTime), gridStartTime),
        });

        // Find the next nearest hour
        const currentLabelTimeDateValue = addHours(userDate(currentLabelTime), 1);
        currentLabelTime = getTimestamp(currentLabelTimeDateValue);

        let isCurrentLabelTimeSameAsEndLabelTime = false;

        while (currentLabelTime <= endLabelTime) {
            if (currentLabelTime === endLabelTime) {
                isCurrentLabelTimeSameAsEndLabelTime = true;
            }

            gridLabels.push({
                labelText: formatTime(userDate(currentLabelTime)),
                top: differenceInMinutes(userDate(currentLabelTime), gridStartTime),
            });

            currentLabelTime = currentLabelTime + TimeConstants.MillisecondsIn1Hour;
        }

        // Now it can happen that endLabelTime is not the last added label as it is not at the hour boundary.
        if (!isCurrentLabelTimeSameAsEndLabelTime) {
            gridLabels.push({
                labelText: formatTime(userDate(endLabelTime)),
                top: differenceInMinutes(userDate(endLabelTime), gridStartTime),
            });
        }

        return gridLabels;
    }
}
